import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import moment from "moment/moment";
import { StringUtils } from "../../../../../core/utils/string_utils";
import TrackingService from "../../../../data/service/impl/tracking_service_impl";

const trackingService = new TrackingService();


// move this to constants file but here in same folder
const CHANGE_PASSWORD_SCREENS = {
    sendOtp: 'sendOtp',
    validateOtp: 'validateOtp',
    changePassword: 'changePassword'
}

const initialState = {
    showModal: false,
    oldPassword: '',
    oldPasswordErrorMessage: '',
    newPassword: '',
    newPasswordErrorMessage: '',
    retypePassword: '',
    retypePasswordErrorMessage: '',
    otp: '',
    otpErrorMessage: '',
    isLoading: false,
    otpLastSent: null,
    screen: CHANGE_PASSWORD_SCREENS.sendOtp,
    showSuccessToast: false,


    showResetPasswordModal: false,
    email: '',
    emailErrorMessage: '',
    showChangePasswordModal: false,
};

export const createChangePasswordSlice = () => {
    return createSlice({
        name: "changePassword",
        initialState,
        reducers: {
            resetState: () => initialState,
            setShowModal: (state, action) => {
                state.showModal = action.payload;
            },
            setOldPassword: (state, action) => {
                state.oldPasswordErrorMessage = '';
                state.oldPassword = action.payload;
            },
            setNewPassword: (state, action) => {
                state.newPassword = action.payload;
                const isPasswordValid = StringUtils.isPasswordValid(action.payload)
                state.newPasswordErrorMessage = isPasswordValid.isValid ?  '' : `New ${isPasswordValid.message}`;
            },
            setRetypePassword: (state, action) => {
                state.retypePassword = action.payload;
                state.retypePasswordErrorMessage = action.payload !== state.newPassword ? 'Passwords do not match' : '';
            },
            setOtp: (state, action) => {
                state.otp = action.payload;
            },
            setShowOtpField: (state, action) => {
                state.showOtpField = action.payload;
            },
            setEmail: (state, action) => {
                state.email = action.payload;
                const validation = StringUtils.isEmailValid(action.payload);
                state.emailErrorMessage = validation.isValid ? '' : validation.message;
            },
            setShowResetPasswordModal: (state, action) => {
                state.showResetPasswordModal = action.payload;
            },
            setShowChangePasswordModal: (state, action) => {
                state.showChangePasswordModal = action.payload;
            }
        },

        extraReducers: (builder) => {
            builder.addCase(sendChangePasswordOtp.pending, (state, action) => {

                state.otpErrorMessage = '';
                state.oldPasswordErrorMessage = '';
                state.newPasswordErrorMessage = '';
                state.retypePasswordErrorMessage = '';
                state.isLoading = true;
            })
            builder.addCase(sendChangePasswordOtp.fulfilled, (state, action) => {
                state.screen = CHANGE_PASSWORD_SCREENS.validateOtp;
                state.isLoading = false;
                state.otpLastSent = moment().format('YYYY-MM-DD HH:mm:ss');
            })
            builder.addCase(validateChangePassOTP.pending, (state, action) => {

                state.isLoading = true;
                state.otpErrorMessage = '';
            })
            builder.addCase(validateChangePassOTP.fulfilled, (state, action) => {
                state.isLoading = false;
                state.screen = CHANGE_PASSWORD_SCREENS.changePassword;
            })
            builder.addCase(validateChangePassOTP.rejected, (state, action) => {
                state.isLoading = false;
                state.otpErrorMessage = 'OTP does not match.';
            })
            builder.addCase(changePassword.pending, (state, action) => {

                state.isLoading = true;
                state.oldPasswordErrorMessage = '';
                state.otpErrorMessage = '';
            })
            builder.addCase(changePassword.fulfilled, (state, action) => {
                state.showSuccessToast = true;
                state.showModal = false;
                state.isLoading = false;
            })
            builder.addCase(changePassword.rejected, (state, action) => {
                state.isLoading = false;
                // console.log('JHS action', action.payload);
                if(action.payload?.data?.length > 0){
                    action.payload.data.forEach(element => {
                        // console.log('JHS element', element);
                        if(element.path === 'oldPassword'){
                            state.oldPasswordErrorMessage = 'Your Old Password does not match.'//element.msg;
                            state.showOtpField = false;
                        }
                    });
                }
            })
            builder.addCase(resetPassword.fulfilled, (state, action) => {
                trackingService.trackEvent("reset_password_success", { userId: state.user.id, distinct_id: state.user.id, timestamp: new Date().toISOString() });
                state.showResetPasswordModal = false;
            }).addCase(resetPassword.pending, (state, action) => {
                trackingService.trackEvent("reset_password_initiated", { userId: state.user.id, distinct_id: state.user.id, timestamp: new Date().toISOString() });
            }).addCase(resetPassword.rejected, (state, action) => {
                trackingService.trackEvent("reset_password_failed", { userId: state.user.id, distinct_id: state.user.id, failure_reason: action.payload.message, timestamp: new Date().toISOString() });
                // state.isLoading = false;
                // state.errorToastMessage = action.payload.message;
            })
            builder.addCase(userChangePassword.pending, (state, action) => {
                state.isLoading = true;
                state.oldPasswordErrorMessage = '';
                state.newPasswordErrorMessage = '';
                state.retypePasswordErrorMessage = '';
                console.log("Tracking event:", state?.profile);
                // trackingService.trackEvent("change_password_initiated", { userId: state.user._id, distinct_id: state.user.id, timestamp: new Date().toISOString() });
            })
            builder.addCase(userChangePassword.fulfilled, (state, action) => {
                state.showSuccessToast = true;
                state.showChangePasswordModal = false;
                state.isLoading = false;
                
                // Reset form fields
                state.oldPassword = '';
                state.newPassword = '';
                state.retypePassword = '';
                state.oldPasswordErrorMessage = '';
                state.newPasswordErrorMessage = '';
                state.retypePasswordErrorMessage = '';
                // trackingService.trackEvent("change_password_success", { userId: state.user._id, distinct_id: state.user.id, timestamp: new Date().toISOString() });
            })
            builder.addCase(userChangePassword.rejected, (state, action) => {
                state.isLoading = false;
                console.log("Tracking event", state);
                if(action.payload?.message) {
                    if(action.payload.message.includes("match")) {
                        state.retypePasswordErrorMessage = action.payload.message;
                    } else if(action.payload.message.includes("Old Password")) {
                        state.oldPasswordErrorMessage = action.payload.message;
                    } else {
                        state.newPasswordErrorMessage = action.payload.message;
                    }
                }
                // trackingService.trackEvent("change_password_failed", { userId: state.user._id, distinct_id: state.user.id, failure_reason: action.payload.message, timestamp: new Date().toISOString() });
            })
        }

    })
}

export const sendChangePasswordOtp = createAsyncThunk(
    'changePassword/sendChangePasswordOtp',
    async (userId, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const result =  await userRepository.sendChangePasswordOtp(userId);
        return result
    }
)

export const validateChangePassOTP = createAsyncThunk(
    'changePassword/validateChangePassOTP',
    async (payload, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const {userId, otp} = payload;
        const result = await userRepository.validateChangePassOTP(userId, otp);

        if(!result.success){
            return rejectWithValue(result);
        }
    
        return result;
    }
)

export const changePassword = createAsyncThunk(
    'changePassword/changePassword',
    async (payload, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const {userId, email, newPassword, oldPassword} = payload;

        const changePasswordResponse = await userRepository.changePassword({userId, email, newPassword, oldPassword});

        if(!changePasswordResponse.success){
            return rejectWithValue(changePasswordResponse);
        }

        return changePasswordResponse;
    }
)

export const resetPassword = createAsyncThunk(
    'changePassword/resetPassword',
    async (payload, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const result = await userRepository.sendRecoveryLink(payload);

        console.log('JHS result', result);

        return result;
    }
)

export const userChangePassword = createAsyncThunk(
    'changePassword/userChangePassword',
    async (payload, { rejectWithValue, extra }) => {
        const userRepository = extra.userRepository;
        const {userId, email, oldPassword, newPassword, confirmPassword} = payload;

        const changePasswordResponse = await userRepository.userChangePassword({
            userId, 
            email, 
            oldPassword, 
            newPassword,
            confirmPassword
        });

        if(!changePasswordResponse.success){
            return rejectWithValue(changePasswordResponse);
        }

        return changePasswordResponse;
    }
)